
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Role } from '@/modules/shared/types';
import { Port } from '@/modules/shared/Port';

@Component({})
export default class RoleGuard extends Vue {

    @Prop({ required: true, default: Role.APP_ADMIN })
    public readonly role!: Role;

    private isCompanyAdmin = false;
    private isAppAdmin = false;

    public created(): void {
        Port.auth.isCompanyAdmin().then((isCompanyAdmin) => (this.isCompanyAdmin = isCompanyAdmin));
        Port.auth.isAppAdmin().then((isAppAdmin) => (this.isAppAdmin = isAppAdmin));
    }

    private get hasRequiredRole(): boolean {
        switch (this.role) {
            case Role.APP_ADMIN: return this.isAppAdmin;
            case Role.COMPANY_ADMIN: return this.isAppAdmin || this.isCompanyAdmin;
            case Role.USER: return true;
            default: return false;
        }
    }

}
